<template>
  <div
    class="card"
    :class="[
      variantClasses,
      className,
      {
        'card-interactive': interactive,
        'card-glow': glow
      }
    ]"
    @click="handleClick"
  >
    <header v-if="$slots.header" class="card-header">
      <slot name="header" />
    </header>
    <div v-if="$slots.media" class="card-media">
      <slot name="media" />
    </div>
    <main class="card-content">
      <slot />
    </main>
    <footer v-if="$slots.footer" class="card-footer">
      <slot name="footer" />
    </footer>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  variant: {
    type: String,
    default: 'elevated',
    validator: val => ['default', 'elevated', 'interactive', 'gradient', 'glass', 'outlined'].includes(val)
  },
  interactive: {
    type: Boolean,
    default: false
  },
  glow: {
    type: Boolean,
    default: false
  },
  class: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['click'])

const variantClasses = computed(() => {
  switch (props.variant) {
    case 'default':
    case 'elevated':
      return 'bg-surface-container-lowest text-on-surface shadow-md border border-outline-variant/20'
    case 'outlined':
      return 'bg-surface-container-lowest text-on-surface border border-outline-variant/40'
    case 'interactive':
      return 'bg-surface-container-lowest text-on-surface shadow-md border border-outline-variant/20 hover:shadow-lg hover:-translate-y-1 cursor-pointer transition-all duration-300'
    case 'gradient':
      return 'bg-gradient-to-br from-surface-container-lowest to-surface-container-low text-on-surface shadow-warm border border-outline-variant/20'
    case 'glass':
      return 'backdrop-blur-md bg-white/70 border border-white/40 shadow-md text-on-surface'
    default:
      return ''
  }
})

const className = computed(() => props.class)

const handleClick = event => {
  if (props.interactive) {
    emit('click', event)
  }
}
</script>
